import React from 'react';
import * as ROUTES from './routes';
import Home from '../assets/leftPanel/home.png';
import User from '../assets/leftPanel/user_selected.png';
import {
  ROLE_ADMIN,
  ROLE_MANAGER,
  ROLE_MARKETING_ADMIN,
  ROLE_MARKETING_MANAGER,
  ROLE_SUPER_ADMIN,
} from './roles';

const Menu = [
  {
    key: '1',
    title: 'Home',
    icon: <img src={Home} alt="" />,
    redirect: ROUTES.DASHBOARD,
    path: [],
    allowedRoles: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_MARKETING_ADMIN,
      ROLE_MARKETING_MANAGER,
    ],
  },
  {
    key: '2',
    title: 'User',
    icon: <img src={User} alt="" />,
    redirect: ROUTES.USER,
    path: [],
    allowedRoles: [ROLE_ADMIN, ROLE_MANAGER],
  },
  {
    // This Sidenav tab is for Marketing Agency Users only
    key: '2',
    title: 'User',
    icon: <img src={User} alt="" />,
    redirect: ROUTES.MARKETING_USER,
    path: [],
    allowedRoles: [ROLE_MARKETING_ADMIN, ROLE_MARKETING_MANAGER],
  },
  {
    key: '2',
    title: 'User',
    icon: <img src={User} alt="" />,
    redirect: ROUTES.SUPER_ADMIN_USER,
    path: [],
    allowedRoles: [ROLE_SUPER_ADMIN],
  },
  {
    key: '3',
    title: 'Product',
    icon: <img src={User} alt="" />,
    path: [],
    allowedRoles: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_MARKETING_ADMIN,
      ROLE_MARKETING_MANAGER,
    ],
    children: [
      {
        key: '4',
        title: 'Catalogue',
        icon: <img src={User} alt="" />,
        redirect: ROUTES.PRODUCT_CATALOGUE,
        allowedRoles: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_MARKETING_ADMIN,
          ROLE_MARKETING_MANAGER,
        ],
      },
      {
        key: '5',
        title: 'Offerings',
        icon: <img src={User} alt="" />,
        redirect: ROUTES.OFFERINGS,
        allowedRoles: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_MARKETING_ADMIN,
          ROLE_MARKETING_MANAGER,
        ],
      },
    ],
  },
  {
    key: '6',
    title: 'Market Place',
    icon: <img src={User} alt="" />,
    redirect: ROUTES.MARKET_PLACE,
    allowedRoles: [ROLE_ADMIN, ROLE_MANAGER],
  },
  // {
  //   key: '7',
  //   title: 'Sampling',
  //   icon: <img src={User} alt="" />,
  //   path: [],
  //   children: [
  //     {
  //       key: '8',
  //       title: 'Orders',
  //       icon: <img src={User} alt="" />,
  //       redirect: ROUTES.SAMPLE_ORDERS,
  //       allowedRoles: [ROLE_ADMIN, ROLE_MANAGER],
  //     },
  //   ],
  //   allowedRoles: [ROLE_ADMIN, ROLE_MANAGER],
  // },
  // {
  //   key: '9',
  //   title: 'Manage Orders',
  //   icon: <img src={User} alt="" />,
  //   path: [],
  //   children: [
  //     {
  //       key: '10',
  //       title: 'Orders',
  //       icon: <img src={User} alt="" />,
  //       redirect: ROUTES.ORDERS,
  //       allowedRoles: [
  //         ROLE_ADMIN,
  //         ROLE_MANAGER,
  //         ROLE_MARKETING_ADMIN,
  //         ROLE_MARKETING_MANAGER,
  //       ],
  //     },
  //     // {
  //     //   key: '11',
  //     //   title: 'Processing',
  //     //   icon: <img src={User} alt="" />,
  //     //   redirect: ROUTES.PROCESSING,
  //     //   allowedRoles: [ROLE_ADMIN, ROLE_MANAGER],
  //     // },
  //     // {
  //     //   key: '12',
  //     //   title: 'Returns',
  //     //   icon: <img src={User} alt="" />,
  //     //   redirect: ROUTES.RETURNS,
  //     //   allowedRoles: [ROLE_ADMIN, ROLE_MANAGER],
  //     // },
  //   ],
  //   allowedRoles: [
  //     ROLE_ADMIN,
  //     ROLE_MANAGER,
  //     ROLE_MARKETING_ADMIN,
  //     ROLE_MARKETING_MANAGER,
  //   ],
  // },
  {
    key: '13',
    title: 'Campaigns',
    icon: <img src={User} alt="" />,
    redirect: ROUTES.CAMPAIGN,
    path: [],
    allowedRoles: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_MARKETING_ADMIN,
      ROLE_MARKETING_MANAGER,
    ],
  },
];

export default Menu;
